if (!customElements.get("swiper-carousel")) {
  class SwiperCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.id = this.dataset.id;
    }

    connectedCallback() {
      this.initCarousel();
      this.setupListeners();
    }

    setupListeners() {
      const pagers = this.querySelectorAll(".carousel-pager");
      const thumbs = this.querySelectorAll(".swiper__thumb");

      const syncThumbsAndPagers = () => {
        const idx = this.swiper.realIndex;
        thumbs.forEach((thumb) => thumb.classList.remove("active"));
        if (thumbs[idx]) {
          thumbs[idx].classList.add("active");
        }
        if (pagers.length) {
          pagers.forEach((el) => el.classList.remove("active"));
          if (pagers[idx]) {
            pagers[idx].classList.add("active");
          }
        }
      };

      this.swiper.on("slideChange", syncThumbsAndPagers);

      this.addEventListener("click", (e) => {
        const button = e.target.closest("button");
        if (button && button.matches(".swiper__thumb")) {
          const idx = Array.from(thumbs).indexOf(button);
          thumbs.forEach((thumb) => thumb.classList.remove("active"));
          button.classList.add("active");
          if (this.swiper.params.loop) {
            this.swiper.slideToLoop(idx);
          } else {
            this.swiper.slideTo(idx);
          }
        }
      });

      pagers.forEach((pager, i) => {
        pager.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.swiper.params.loop) {
            this.swiper.slideToLoop(i);
          } else {
            this.swiper.slideTo(i);
          }
        });
      });
    }

    initCarousel() {
      const paginationEl = this.querySelector(".carousel-pagination");
      const config = {
        fadeEffect: { crossFade: true },
        effect: "fade",
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.querySelector(".carousel-next"),
          prevEl: this.querySelector(".carousel-prev"),
        },
        breakpoints: {
          1024: {
            loop: true,
          },
        },
      };

      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          type: "progressbar",
        };
      }

      this.swiper = new Swiper(`#${this.id} .swiper`, config);
    }
  }

  customElements.define("swiper-carousel", SwiperCarousel);
}
